// businessUtils.js
// 统一管理所有前端业务相关工具函数

/**
 * 解析AM35 SN码
 * @param {string} sn SN码字符串
 * @returns {object|null} 解析结果对象
 */
export function parseAM35SN(sn) {
  try {
    // 基础校验
    if (!sn || typeof sn !== 'string' || sn.length < 15) {
      return null;
    }
    
    // 校验是否为全0或全相同字符（无效SN）
    if (/^(.)\1*$/.test(sn)) {
      return null;
    }
    
    // 机型（2位，36进制）
    const model36 = sn.slice(0, 2);
    // SKU（1位，A-Z）
    const sku = sn.slice(2, 3);
    // 年份（2位）
    const year = sn.slice(3, 5);
    // 季度（2位，A/B/C/D + 数字）
    const quarter = sn.slice(5, 7);
    // 递增序号（4位）
    const serial = sn.slice(7, 11);
    // 随机位数（4位）
    const random = sn.slice(11, 15);
    
    // 校验关键字段是否有效
    // model36: 36进制，应该是数字或字母
    // sku: A-Z字母
    // year: 数字
    // quarter: A/B/C/D开头+数字
    if (!model36 || !/^[0-9A-Z]{2}$/i.test(model36) ||
        !sku || !/^[A-Z]$/i.test(sku) ||
        !year || !/^\d{2}$/.test(year) ||
        !quarter || !/^[A-D]\d$/i.test(quarter)) {
      return null;
    }
    
    return {
      model36,
      sku,
      year,
      quarter,
      serial,
      random,
    };
  } catch (e) {
    // 捕获异常，返回null
    return null;
  }
}

/**
 * 根据SN码解析结果，返回设备图片key（可用于图片映射）
 * @param {object} snInfo SN解析结果
 * @returns {string} 图片key
 */
export function getAM35DeviceImageKey(snInfo,isDongle=false) {
    try {
      const defaultImg = isDongle?'device_am35_d_a':'device_am35_a'
      if (!snInfo || typeof snInfo !== 'object') return defaultImg;
      // 例如：机型+SKU+季度
      const { model36 = '', sku = '' } = snInfo;
      if (!model36 || !sku ) return defaultImg;
        return `device_am35${isDongle?'_d':''}_${snInfo.sku.toLowerCase()}`;
    } catch (e) {
     return defaultImg;
    }
  }

  /**
   * 根据SN码解析结果，返回渲染图片key（可用于图片映射）
   * @param {object} snInfo SN解析结果
   * @returns {string} 图片key
   */
  export function getAM35MianImageKey(snInfo) {
    try {
      if (!snInfo || typeof snInfo !== 'object') return 'device_am35_m_a';
      // 例如：机型+SKU+季度
      const { model36 = '', sku = '' } = snInfo;
      if (!model36 || !sku ) return 'device_am35_m_a';
        return `device_am35_m_${snInfo.sku.toLowerCase()}`;
    } catch (e) {
     return `device_am35_m_a`;
    }
}
// 更多业务逻辑可在此扩展
